// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"0a19aa55","291":"31bfbf16","397":"e72924a0","491":"d875b743","753":"ffb6fd1f"}[chunkId] + ".chunk.js";
};